export default "e662e9d28a5f6da6.svg"